<div *ngIf='option' id="{{option.id}}tab" class="list" [class.active]=option.isActive>
  <a href="javascript:void(0)" (click)="selectTab(option)" role="tab" id="{{option.id}}-tab" 
      [attr.tabindex]="option.isActive ? 0 : -1"
      [attr.aria-selected]="option.isActive ? true : false"
      [attr.aria-controls]="option.id" [attr.aria-expanded]="option.isActive ? true : false">
        {{option.id}} 
        <i *ngIf=!option.isActive class="icon-accordion-plus"></i>
        <i *ngIf=option.isActive class="icon-accordion-minus"></i>
  </a>
</div>
<div class="tab-content" attr.aria-labelledby="{{option.id}}-tab" id={{option.id}} [attr.aria-hidden]="!option.isActive ? true : false" *ngIf="option.isActive">
    <ng-content></ng-content>
</div>